import { Key } from "@zapier/design-system";

export function createConnectionShareFromId(id: Key, shareType: any) {
  return {
    id,
    shareType,
    email: "",
    name: "",
    photoUrl: "",
  };
}
